export type EmailEventType = 'Send' | 'Delivery' | 'Bounce' | 'Complaint' | 'Reject' | 'Open' | 'Click';

export const EMAIL_EVENT_TYPES: readonly EmailEventType[] = [
  'Send',
  'Delivery',
  'Bounce',
  'Complaint',
  'Reject',
  'Open',
  'Click',
];

export interface IEmailEventView {
  readonly id: string;
  readonly messageId: string;
  readonly recipientEmail: string;
  readonly eventType: EmailEventType;
  readonly timestamp: string;
  readonly configSet: string | null;
  readonly subType: string | null;
  readonly source: string | null;
}

export interface IEmailLogsPagedResult {
  readonly pageNumber: number;
  readonly pageSize: number;
  readonly total: number;
  readonly results: readonly IEmailEventView[];
}

export interface IEmailLogsQuery {
  readonly email?: string;
  readonly types?: readonly EmailEventType[];
  readonly since?: string;
  readonly until?: string;
  readonly pageNumber: number;
  readonly pageSize: number;
}
